import React from "react"

const UTF8_BOM = "\uFEFF"

const withUtf8Bom = csvData => {
  if (typeof csvData === "string") {
    return csvData.charCodeAt(0) === 0xfeff ? csvData : `${UTF8_BOM}${csvData}`
  }
  return csvData
}

const DownloadCSV = (csvData, fileName) => {
  const payload = withUtf8Bom(csvData)
  const blob = new Blob([payload], { type: "text/csv;charset=utf-8;" })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", `${fileName}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export default DownloadCSV

